



module.exports = {
  "downloadhelper": () => import("./scenes/downloadhelper.js"),
  "piechart": () => import("./scenes/piechart.js"),
  "receipt": () => import("./scenes/receipt.js"),
  "underground": () => import("./scenes/underground.js")
}